/**
 * @description http://stackoverflow.com/questions/22710241/angularjs-disable-button-on-http-q-calls
 */
;(function () {
  angular.module('contrast.ui').directive('clickAndDisable', clickAndDisable)

  function clickAndDisable() {
    return {
      scope: {
        clickAndDisable: '&'
      },
      link: function (scope, iElement) {
        iElement.on('click', function () {
          iElement.prop('disabled', true)
          scope.clickAndDisable().finally(function () {
            iElement.prop('disabled', false)
          })
        })
      }
    }
  }
})()
